import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

var numeral = require('numeral');
var _ = require('lodash');

function InvoiceRows(invoice_data) {
    const inner_invoice_rows = _.map(invoice_data,(i, key) => {
      return (
        <tr key={key}>
          <td>{key + 1}</td>
          <td>
          <Link to={"/sale/invoice/detail/"+i.invoice_id}>{i.invoice_code}</Link>
          </td>
          <td>
            <Link to={"#"}>{i.user.email}</Link>
            <br/>
            {i.user.agency && !i.user.agency.has_custom_brand && <small className="text-muted"> <strong>Đại lý:</strong> {i.user.agency.agency_admin.email}</small>}
            {i.user.agency && i.user.agency.has_custom_brand && <small className="text-muted"> <strong>Thương hiệu riêng:</strong> {i.user.agency.agency_admin.email}</small>}
            {!i.user.agency && <small className="text-muted"> <strong>Khách lẻ</strong> </small>}
          </td>	
          <td>
            {moment(i.payment_date).format("DD-MM-YYYY HH:mm:ss")}
          </td>
          <td>
            {moment(i.created_date).format("DD-MM-YYYY HH:mm:ss")}
          </td>
          <td>
            {numeral(i.invoice_total).format('0,0')} đ
          </td>
          <td>
            {numeral(i.commission).format('0,0')} đ
          </td>
        </tr>
      )
    })
  return inner_invoice_rows;
}

class SaleCommissionReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table_data: [],
      start_date_of_previous_month: moment().subtract(1,'months').startOf('month'),
      end_date_of_previous_month: moment().subtract(1,'months').endOf('month')
    }
  }

  componentDidMount() {
    this.listReload();
  }
  
  listReload = () => {
    const { start_date_of_previous_month } = this.state;
    const self = this;
    
    axios({
      method: 'get',
      url: window.api_url + `/admin/api/report/commission-by-sale/${start_date_of_previous_month.format("M")}/${start_date_of_previous_month.year()}`,
      withCredentials: true,
    }).then(function (response) {
      self.setState({
        table_data: response.data.data
      })
    });
  }

  render() {
    const { table_data, start_date_of_previous_month, end_date_of_previous_month } = this.state;
    
    return(
      table_data && <React.Fragment> 
        <div className="page-header">
          <h4>
            <i className="icon-paragraph-justify2"></i>
            <span className="text-semibold"> Danh sách đơn hàng liên quan</span>
          </h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive">
                <h4 style={{padding: "15px"}}>
                  Từ ngày {start_date_of_previous_month.format("DD/MM/YYYY")} đến ngày {end_date_of_previous_month.format("DD/MM/YYYY")}
                </h4>
                <h4 style={{padding: "15px"}}>
                  Tổng huê hồng: { numeral(_.sumBy(table_data, (i) => i.commission)).format("0,0") }
                </h4>
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>STT</th>
                      <th>Mã Đơn Hàng</th>
                      <th>Khách Hàng</th>
                      <th>Ngày Thanh Toán</th>
                      <th>Ngày đăng ký</th>
                      <th>Tổng Tiền (Không gồm VAT) </th>
                      <th>Hoa Hồng</th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data && InvoiceRows(table_data)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path,
});

const mapDispatch = (dispatch) => ({

});

export default connect(mapState, mapDispatch)(withRouter(SaleCommissionReport));